// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2ckJ3","choiceBoxes":"toolbarselects_choiceBoxes__3NoLe","simpleField":"toolbarselects_simpleField__2Ywcj"};